module.exports = __webpack_public_path__ + "img/logo_full.5012059b.png";